module.exports = __webpack_public_path__ + "img/6.ee6c1363.jpg";